var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_c('img',{attrs:{"id":"ai-img","src":_vm.logoUrl}}),_c('canvas',{attrs:{"id":"ai-canvas","width":"1024","height":"1024"}})])}
var staticRenderFns = []

export { render, staticRenderFns }